import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * SidebarSection component renders a section header in the sidebar
 *
 * @param {Object} props - Component props
 * @param {string} props.title - Title of the section
 * @param {boolean} props.isCollapsed - Whether the sidebar is collapsed
 */
const SidebarSection = ({ title, isCollapsed }) => {
	const theme = useTheme();

	// When sidebar is collapsed, don't render the header
	if (isCollapsed) {
		return null;
	}

	return (
		<Box sx={{ mt: 2, mb: 0.5, px: 2 }}>
			<Typography
				variant='caption'
				sx={{
					color: theme.palette.text.secondary,
					fontWeight: 600,
					textTransform: 'uppercase',
					fontSize: '0.75rem',
					letterSpacing: '0.08rem',
				}}
			>
				{title}
			</Typography>
		</Box>
	);
};

export default SidebarSection;
